import type { Styles } from 'src/theme/themes';

export const styles: Styles = {
  changelogContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    paddingBlock: theme.spacing(2.75),
  }),
  changelogRow: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    alignItems: 'baseline',
    justifyContent: 'space-between',
  }),
  changelogRowIconBox: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    width: theme.spacing(4),
    height: theme.spacing(4),
    borderRadius: '40px',
    backgroundColor: theme.colors.neutral[100],
  }),
  changelogRowContents: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    alignItems: 'start',
    justifyContent: 'center',
    flexGrow: 1,
  }),
  changelogRowDescriptionText: (theme) => ({
    color: theme.colors.neutral[500],
    fontWeight: 500,
  }),
  changelogRowDateText: (theme) => ({
    color: theme.colors.neutral[500],
    fontWeight: 600,
  }),
  changelogCommentBox: (theme) => ({
    borderStyle: 'solid',
    borderRadius: '0 8px 8px 8px',
    borderWidth: '1px',
    borderColor: theme.colors.neutral[100],
    padding: theme.spacing(1),
    color: theme.colors.neutral[500],
  }),
};
